import { useSoftDeployAccess } from 'App/components/hooks';
import useTaskMapAllowed from 'App/pages/TaskMap/allowed';

export default function useTaskVisitsAllowed() {
	const hasTaskMap = useTaskMapAllowed();
	const hasFieldSales = useSoftDeployAccess('FIELD_SALES_V2');
	return hasTaskMap && hasFieldSales;
}
